import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';

export default function Careers() {
    const navigate = useNavigate();

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#f7fdf9' }}>
            <Header />
            
            <div style={{ 
                flex: 1, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                padding: '40px 20px'
            }}>
                <div style={{
                    background: '#fff',
                    borderRadius: '24px',
                    padding: '60px 40px',
                    maxWidth: '600px',
                    width: '100%',
                    textAlign: 'center',
                    boxShadow: '0 20px 40px rgba(13, 36, 16, 0.08)',
                    border: '1px solid rgba(45, 106, 79, 0.1)'
                }}>
                    <div style={{ fontSize: '4rem', marginBottom: '20px', animation: 'bounce 2s infinite' }}>🚀</div>
                    
                    <h1 style={{ 
                        fontFamily: 'Playfair Display, serif', 
                        fontSize: '2.5rem', 
                        color: '#1a2e1a',
                        marginBottom: '16px'
                    }}>
                        Careers at VaidyaMed-X
                    </h1>
                    
                    <div style={{
                        display: 'inline-block',
                        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                        color: '#fff',
                        padding: '6px 16px',
                        borderRadius: '999px',
                        fontSize: '0.9rem',
                        fontWeight: '700',
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        marginBottom: '24px'
                    }}>
                        Coming Soon
                    </div>
                    
                    <p style={{ color: '#475569', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '32px' }}>
                        We are currently building our team and crafting exciting new roles where you can help us blend ancient Ayurvedic wisdom with futuristic AI. Check back soon for open positions!
                    </p>
                    
                    <button 
                        onClick={() => navigate('/')}
                        style={{
                            background: 'linear-gradient(135deg, #2d6a4f 0%, #1a4228 100%)',
                            color: '#fff',
                            border: 'none',
                            padding: '12px 32px',
                            borderRadius: '50px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 14px rgba(45, 106, 79, 0.3)'
                        }}
                        onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                        onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        Return to Home
                    </button>
                </div>
            </div>

            <Footer />
            
            <style>{`
                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-15px); }
                }
            `}</style>
        </div>
    );
}
